<template>
  <div v-tooltip="presentation.privateMode ? publicModeTooltip : privateModeTooltip">
    <li class="sidebar-item pointer" @click.stop="isModalPrivateModeVisile = true">
      <a class="sidebar-link waves-effect waves-dark sidebar-link-custom">
        <span
          v-if="presentation.privateMode"
          class="whitespace-normal horizontal layout center"
        >
          <i class="far fa-eye fa-fw sidebar-link-icon" />
          <span class="hide-menu nav-left-text">{{ $t('Switch to public') }}</span>
        </span>
        <span
          v-if="!presentation.privateMode"
          class="whitespace-normal horizontal layout center"
        >
          <i class="far fa-eye-slash fa-fw sidebar-link-icon" />
          <span class="hide-menu nav-left-text">{{ $t('Switch to private') }}</span>
        </span>
      </a>
    </li>
    <ModalPresentingPrivateMode
      @hideModal="isModalPrivateModeVisile = false"
      v-if="isModalPrivateModeVisile"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ModalPresentingPrivateMode from '@/components-v2/modals/PresentingPrivateMode.vue'

export default {
  components: {
    ModalPresentingPrivateMode,
  },
  data: () => ({
    isModalPrivateModeVisile: false,
  }),
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    publicModeTooltip() {
      return this.$i18nPresenter.t('Public: Audience can see and interact with your slides')
    },
    privateModeTooltip() {
      return this.$i18nPresenter.t('Private: Audience cannot see or interact with your slides')
    },
  },
}
</script>

<style  lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.sidebar-item {
  width: unset;
  .sidebar-link {
    &.sidebar-link-custom {
      white-space: normal;
    }
    &:hover {
      .fas, .far {
        color: $primary-color;
      }
    }
    .sidebar-link-icon {
      font-size: 20px;
      margin-right:12px;
    }
  }
  .active {
    background-color: rgba(0, 0, 0, 0.07);
  }
  .nav-left-text {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: 16px;
  }
}
</style>
